<template>

    <Page>
        <div class="max-h-[70%] !min-w-[90%] bg-white rounded-lg overflow-hidden shadow-2xl ring-[0.25em] ring-white/[25%]">
            <Image 
                src="/History/dealercell.jpg"
                class="h-full object-cover mx-auto overflow-hidden" 
            />
        </div>
    </Page>

</template>